import * as types from "./priorStateActionTypes";

export const clearPriorState = () => ({
  type: types.CLEAR_PRIOR_STATE,
});
